//Use this function throughout the app, to export the CSV by passing content and fileName as params.
export const CSVExport = {
   exportCSV (content, fileName) {
    const dt = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(content);
    const link = document.createElement("a");
    link.setAttribute("href", dt);
    link.setAttribute("download", fileName);
    link.click();
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CSVExport.js